import { typographyVariants } from '@mint-lib/tw-components';

type Props = { data: string[] };

/*FYI:At the moment, double file extensions (mostly .txt) often appear.
 This is a bug on the DS side, but in order not to block the release, we decided to temporarily fix it on the UI side.
*/
function fixFileName(fileName: string): string {
  if (!fileName.endsWith('.txt')) {
    return fileName;
  }

  const withoutTxt = fileName.slice(0, -4);
  const lastDotIndex = withoutTxt.lastIndexOf('.');

  if (lastDotIndex !== -1) {
    const beforeExtension = withoutTxt.slice(0, lastDotIndex);
    const originalExtension = withoutTxt.slice(lastDotIndex);

    if (beforeExtension.endsWith('_')) {
      return beforeExtension.slice(0, -1) + originalExtension;
    }

    return withoutTxt;
  }

  return fileName;
}

const KnowledgeBaseTabData = ({ data }: Props) => {
  return (
    <div className="flex flex-col gap-3">
      <ul className="list-disc space-y-2 pl-4">
        {data.map((doc) => (
          <li
            key={doc}
            className={typographyVariants({
              variant: 'bodyLong01',
            })}
          >
            {fixFileName(doc)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export { KnowledgeBaseTabData };
